import { useState } from "react";
import styles from "./ReportsCashiers.module.css";
import CustomSelect from "../../customComponents/CustomSelect";

const ReportsCashiers = () => {
  const [filters, setFilters] = useState({
    department: "",
    cashier: "",
    shift: "",
    date: "",
  });

  const cashiersData = [
    {
      name: "Иванов Иван",
      totalSales: "150 000 ₸",
      cash: "40 000 ₸",
      card: "110 000 ₸",
      refund: "5 000 ₸",
      total: "145 000 ₸",
      status: "Активен",
    },
    {
      name: "Петров Петр",
      totalSales: "120 000 ₸",
      cash: "50 000 ₸",
      card: "70 000 ₸",
      refund: "3 000 ₸",
      total: "117 000 ₸",
      status: "Активен",
    },
  ];

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Отчеты по кассирам</h2>
      <p className={styles.subtitle}>
        Здесь можно анализировать продажи и выручку по каждому кассиру.
      </p>

      <div className={styles.filters}>
        <CustomSelect
          label="Отдел"
          options={["Главный", "Филиал 1", "Филиал 2"]}
          value={filters.department}
          onChange={(value) => handleFilterChange("department", value)}
        />
        <CustomSelect
          label="Кассир"
          options={["Иванов Иван", "Петров Петр", "Сидорова Анна"]}
          value={filters.cashier}
          onChange={(value) => handleFilterChange("cashier", value)}
        />
        <CustomSelect
          label="Смена"
          options={["Первая", "Вторая", "Ночная"]}
          value={filters.shift}
          onChange={(value) => handleFilterChange("shift", value)}
        />
        <div className={styles.dateInput}>
          <input
            type="date"
            value={filters.date}
            onChange={(e) => handleFilterChange("date", e.target.value)}
          />
        </div>
      </div>

      <table className={styles.table}>
        <thead>
          <tr>
            <th>Кассир</th>
            <th>Сумма по продажам</th>
            <th>Наличными</th>
            <th>Безналичными</th>
            <th>Возврат</th>
            <th>Итого</th>
            <th>Статус</th>
          </tr>
        </thead>
        <tbody>
          {cashiersData.map((row, index) => (
            <tr key={index}>
              <td>{row.name}</td>
              <td>{row.totalSales}</td>
              <td>{row.cash}</td>
              <td>{row.card}</td>
              <td>{row.refund}</td>
              <td>{row.total}</td>
              <td>{row.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ReportsCashiers;
